export default {
  // 錢包餘額
  walletBalanceTitle: "錢包地址總餘額（USDT）",
  walletBalanceTooltip:
    "錢包地址總資產餘額目前暫只統計（ETHEREUM、TRON、BSC、BTC、polygon等五條鏈地址的餘額）\n\n根據本系統已收錄的幣種價值，按地址持有的所有主幣和代幣折算USDT的總餘額",
  clickToUpdate: "點擊右邊按鈕更新餘額",
  update: "更新",
  partialUpdateSuccess: "（部分地址餘額更新成功）",

  // 賬戶總資產
  accountTotalAssets: "賬戶總資產預覽(USDT)",

  // 基礎信息
  basicInformation: "基礎信息",
  addCharacter: "添加人物",
  viewDetails: "查看詳情",
  characterSyncFailed: "人物信息同步失敗",

  // 基礎信息字段
  userId: "用戶ID",
  name: "姓名",
  username: "用戶名",
  nationality: "國籍",
  idNumber: "證件號",
  homePlace: "籍貫",
  sex: "性別",
  phone: "手機號",
  email: "郵箱",
  registerTime: "註冊時間",
  relatedCase: "關聯案件",
  note: "備註",

  // Bitpie 特殊字段
  bindingPhoneTime: "綁定手機時間",
  analysisId: "分析ID",

  // imToken 特殊字段
  deviceId: "設備ID",
  firstUseTime: "首次使用時間",

  // 金融信息
  financialInformation: "金融信息",
  spotTrading: "幣幣交易",
  paymentInfo: "收款信息",
  walletAddress: "錢包地址",
  usedAddresses: "使用過的地址",
  watchedAddresses: "觀察過的地址",

  // 錢包賬戶
  walletAccount: "錢包賬戶",
  noBankFound: "暫無查詢到相關銀行",
  wechat: "微信",
  alipay: "支付寶",

  // 加載更多
  loadMore: "條數據，加載更多",
  collapse: "收起",

  // 狀態
  has: "有",
  none: "無",

  // 消息提示
  copySuccess: "複製成功",
};
